// THE CONDITION STEP'S "PHOTOS ARE YOUR STRONGEST EVIDENCE" BLOCK, DRAWN (R-pending-web-photo-block).
//
// The words are Tyler's, 2026-10-22, "3 yes", and are in `photoBlockWording.ts` with their approval beside them. This file
// draws them and says nothing of its own. `douglas` is the step's one decision (`isDouglasCountyNebraska`, from the subject's
// state and county): true shows the whole approved block, false shows only the pieces that are not Douglas-specific — the
// heading, the intro's first sentence, "What to photograph" and the tip. Every sentence is stamped `data-held-copy`, as every
// word this client holds is.

import { PHOTO_BLOCK_EXAMPLES, photoWords, type PhotoBlockWordingId } from "./photoBlockWording";

function Words({ id, as: Tag = "span" }: { id: PhotoBlockWordingId; as?: "h2" | "p" | "li" | "span" | "b" }) {
  return <Tag data-held-copy={id}>{photoWords(id)}</Tag>;
}

export function PhotoBlock({ douglas }: { douglas: boolean }) {
  return (
    <section className="brand-card photo-block" data-card="photo-tips" data-photo-block={douglas ? "douglas" : "general"}>
      <h2 className="photo-block-title" data-held-copy="photoBlock.heading">{photoWords("photoBlock.heading")}</h2>
      <p className="photo-block-intro">
        <Words id="photoBlock.lead" />
        {douglas && <>{" "}<Words id="photoBlock.examplesLead" /></>}
      </p>
      {douglas && (
        <ul className="photo-block-examples">
          {PHOTO_BLOCK_EXAMPLES.map((id) => <Words key={id} id={id} as="li" />)}
        </ul>
      )}
      <p className="photo-block-what">
        <Words id="photoBlock.whatLabel" as="b" /> <Words id="photoBlock.whatList" />
      </p>
      <p className="photo-block-tip">
        <Words id="photoBlock.tipLabel" as="b" /> <Words id="photoBlock.tip" />
      </p>
    </section>
  );
}
